import { styled } from 'linaria/react';
import { theme } from '../../../components/Theme';
import { toRem } from '../../../helpers';

const ImageContainerWrapper = styled('div')`
  img {
    max-height: 100vh;
  }
  .image-gallery {
    z-index: 140;
  }
  .image-gallery-image {
    text-align: center;
  }
  .image-gallery-slide.center {
    display: contents;
  }
  .image-gallery-content.fullscreen {
    ${theme.above.md} {
      display: flex;
      justify-content: center;
    }
  }
  .image-gallery-thumbnails-container {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    flex-wrap: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;

    ::-webkit-scrollbar {
      display: none;
    }
  }
  .image-gallery-thumbnail {
    width: ${toRem(80)};
    border-radius: ${toRem(8)};
    overflow: hidden;
    border: 1px solid rgba(100, 100, 100, 0.25);
    margin-bottom: ${toRem(8)};
    flex: 0 0 auto;
    .image-gallery-thumbnail-image {
      opacity: 0.25;
    }

    &.active {
      border: 1px solid ${theme.colorScheme.black};
      .image-gallery-thumbnail-image {
        opacity: 1;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:not(.active) {
      .video::after {
        content: url('../../../assets/svg/Play.svg');
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .image-gallery-right-nav,
  .image-gallery-left-nav,
  .image-gallery-fullscreen-button {
    z-index: 3;
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    transition: background 0.3s ease-in-out;
    margin: 0 0.5rem;
    &:hover {
      background: rgba(255, 255, 255, 0.8);
    }
    &:before {
      color: black;
      text-shadow: none;
    }
  }
  .image-gallery-fullscreen-button {
    ::before {
      text-shadow: none;
      font-size: 0.7em;
      padding: 0;
      position: absolute;
      left: ${toRem(9)};
    }
    &.active {
      ::before {
        content: url('../../../assets/svg/ZoomOut.svg');
      }
    }
    :not(.active) {
      ::before {
        content: url('../../../assets/svg/ZoomIn.svg');
      }
    }
  }
  .image-gallery-right-nav {
    padding-left: ${toRem(3)};
    ::before {
      line-height: ${toRem(9)};
      content: url('../../../assets/svg/ChevronRight.svg');
    }
  }
  .image-gallery-left-nav {
    padding-right: ${toRem(3)};
    ::before {
      line-height: ${toRem(9)};
      content: url('../../../assets/svg/ChevronLeft.svg');
    }
  }

  .image-gallery-thumbnail.active {
    border-width: 1px;
  }
  .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails,
  .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .fullscreen {
    .image-gallery-fullscreen-button {
      margin: 1rem;
      ${theme.above.md} {
        margin: 2rem;
      }
    }
    .image-gallery-right-nav,
    .image-gallery-left-nav {
      margin: 0 1rem;
      ${theme.above.md} {
        margin: 0 2rem;
      }
    }
    img {
      width: auto;
      max-width: 100%;
    }
  }

  .image-gallery-bullets {
    position: relative;
    margin: 1rem 3.5rem 0 0;
    bottom: auto;
    min-height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    width: auto;
    z-index: 3;
    ${theme.above.lg} {
      width: calc(100% - (60px * 2));
      margin-left: auto;
      margin-right: auto;
    }
    .image-gallery-bullets-container {
      margin: -3px;
    }
    .image-gallery-bullet {
      margin: 3px;
      background-color: white;
      border: 1px solid ${theme.colorScheme.black};
      height: ${toRem(10)};
      width: ${toRem(10)};
      transform: scale(1);
      box-shadow: none;

      &.active {
        transform: scale(1);
        background-color: black;
        box-shadow: 0px 0px 0px 1px ${theme.colorScheme.white};
      }
    }
  }
`;

const style = {
  ImageContainerWrapper
};

export default style;
